<template>
    <div class="form-row">
        <slot />
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "FormRow",
});
</script>

<style>
@import "@/style/components/forms/forms.css";
</style>
